import React from 'react';
import { connect } from 'react-redux';
import {
  Row,
  Col,
  Input,
  Table,
} from 'reactstrap';
import SiteList from './SiteList';
import EditSiteModal from './edit-site';
import details from './models';

class Admin extends React.PureComponent {
  render() {
    return (
      <main className="p-5">
        <Row>
          <Col>
            <h2 className="mb-3 font-weight-bold">Site Configurations</h2>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="border bg-white pt-5 h-100 shadow-sm">
              <Row className="mb-4">
                <Col className="d-flex">
                  <div className="d-inline-block align-middle ms-5">
                    <Input
                      placeholder="Search"
                      className="border"
                    />
                  </div>
                </Col>
              </Row>

              <Table size="sm" className="font-small mb-0">
                <thead className="bg-gray">
                  <tr>
                    <th> </th>
                    {details.map((model) => (
                      <th className="p-2" key={model.id}>
                        {model.name}
                      </th>
                    ))}
                    <th> </th>
                  </tr>
                </thead>

                <SiteList />
              </Table>
            </div>
          </Col>
        </Row>

        <EditSiteModal />
      </main>
    );
  }
}

export default connect()(Admin);
